import styled from "styled-components";
import { space, color, typography, border} from 'styled-system'

export const LabelWrap = styled.label `
    ${space}
    ${color}
    ${typography}
    ${border}
`;